import { render, staticRenderFns } from "./addLive.vue?vue&type=template&id=efc99788&scoped=true&"
import script from "./addLive.vue?vue&type=script&lang=js&"
export * from "./addLive.vue?vue&type=script&lang=js&"
import style0 from "./addLive.vue?vue&type=style&index=0&id=efc99788&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc99788",
  null
  
)

export default component.exports